// Product configuration for French Curl Studio
export const BRAND = {
  name: "French Curl Vibes",
  legalName: "MAGADMIN",
  whatsappNumber: "33617700400", // +33 6 17 70 04 00
  email: "hairstyle45000@gmail.com",
  partnersEmail: "hairstyle45000@gmail.com",
  instagram: "@frenchcurlvibes",
  address: "19 rue Charles Jeune, 45650 Saint-Jean-le-Blanc, France",
  siren: "945 246 149",
  vat: "FR26944246149",
};

export const PRODUCT = {
  name: "French Curl Braids",
  tagline: "La tresse signature, posée minute, tenue éternelle.",
  price: 7.5,
  description:
    "Notre French Curl est conçue à partir d'une fibre douce, légère et thermo-réglable à l'eau chaude. Une chute parfaite, un toucher soyeux et une tenue qui ne s'effiloche pas. Pensée pour les femmes qui aiment se coiffer vite et bien.",
  bullets: [
    "Fibre légère, anti-frisotis",
    "Réglable à l'eau chaude",
    "Démêlable, ne s'emmêle pas",
    "Longueur unique 24\" — disponible en 60+ teintes",
  ],
};

// Delivery options
export const SHIPPING_OPTIONS = [
  { id: "fr", label: "Livraison France", price: 5.9, eta: "2 à 4 jours ouvrés", description: "Colissimo suivi en France métropolitaine." },
  { id: "eu", label: "Livraison Europe", price: 9.9, eta: "4 à 7 jours ouvrés", description: "Expédition vers tous les pays de l'UE." },
  { id: "clickcollect", label: "Click & Collect salon partenaire", price: 0, eta: "24 à 48h", description: "Retrait gratuit dans un salon partenaire." },
];

// Categories for color grouping
const C = {
  natural: "Naturels & Blonds",
  vivid: "Couleurs vives",
  pastel: "Pastels & Roses",
  ombreT: "Ombré 2 tons (T)",
  pianoP: "Mèches Piano (P)",
  ombreOT: "Ombré 3 tons (OT)",
  curly: "Curly C-Series",
};

export const COLORS = [
  // ─── Naturels & blonds ───
  { id: "1b", name: "1B Noir naturel", code: "1B", swatch: "#0d0a08", category: C.natural },
  { id: "4", name: "Brun chocolat", code: "4#", swatch: "#3a261a", category: C.natural },
  { id: "24", name: "Blond miel", code: "24#", swatch: "#b58d52", category: C.natural },
  { id: "27", name: "Blond caramel", code: "27#", swatch: "#a76a2e", category: C.natural },
  { id: "613", name: "Blond platine", code: "613", swatch: "#e8d6a5", category: C.natural },
  { id: "30", name: "Auburn cuivré", code: "30#", swatch: "#8b4a22", category: C.natural },
  { id: "350", name: "Roux feu", code: "350", swatch: "#9c2e15", category: C.natural },
  { id: "33", name: "Brun rougeâtre", code: "33#", swatch: "#5c2410", category: C.natural },
  { id: "99j", name: "Burgundy", code: "99J", swatch: "#3a0a16", category: C.natural },
  { id: "gold", name: "Or jaune", code: "GOLD", swatch: "#dcb821", category: C.natural },

  // ─── Couleurs vives ───
  { id: "white", name: "Blanc neige", code: "WHITE", swatch: "#f6f4f0", category: C.vivid },
  { id: "grey1", name: "Gris argenté", code: "GREY1", swatch: "#c5c5c8", category: C.vivid },
  { id: "grey2", name: "Gris fumé", code: "GREY2", swatch: "#76767a", category: C.vivid },
  { id: "grey3", name: "Gris anthracite", code: "GREY3", swatch: "#4a4a4f", category: C.vivid },
  { id: "red", name: "Rouge passion", code: "RED", swatch: "#c01a16", category: C.vivid },
  { id: "purple", name: "Violet électrique", code: "PURPLE", swatch: "#8b1ab1", category: C.vivid },
  { id: "rpur", name: "Violet royal", code: "R.PUR", swatch: "#6d10a3", category: C.vivid },
  { id: "tpur", name: "Lilas pastel", code: "T.PUR", swatch: "#c5a5d3", category: C.vivid },
  { id: "dpur", name: "Prune profonde", code: "D.PUR", swatch: "#3d1056", category: C.vivid },
  { id: "bug", name: "Bordeaux", code: "BUG", swatch: "#5a1424", category: C.vivid },
  { id: "inkblue", name: "Bleu encre", code: "INK.BLUE", swatch: "#0e1633", category: C.vivid },
  { id: "green", name: "Vert sapin", code: "GREEN", swatch: "#0e4d3a", category: C.vivid },
  { id: "orange", name: "Orange vif", code: "ORANGE", swatch: "#ec6515", category: C.vivid },

  // ─── Pastels & roses ───
  { id: "pink", name: "Rose bonbon", code: "PINK", swatch: "#e8a4c5", category: C.pastel },
  { id: "dpink", name: "Rose poudré", code: "DPINK", swatch: "#d68aa6", category: C.pastel },
  { id: "bbpink", name: "Rose fuchsia", code: "BB.PINK", swatch: "#d23d80", category: C.pastel },
  { id: "tpink2", name: "Rose nude", code: "T.PINK2", swatch: "#c4836f", category: C.pastel },
  { id: "tpink3", name: "Rose blush", code: "T.PINK3", swatch: "#c89a8a", category: C.pastel },

  // ─── Ombré 2 tons (T) ───
  { id: "t1bbug", name: "Noir → Bordeaux", code: "T.1B/BUG", swatch: "linear-gradient(180deg,#0d0a08 0%,#0d0a08 45%,#5a1424 100%)", category: C.ombreT },
  { id: "t1bpur", name: "Noir → Violet", code: "T.1B/PUR", swatch: "linear-gradient(180deg,#0d0a08 0%,#0d0a08 45%,#8b1ab1 100%)", category: C.ombreT },
  { id: "t27", name: "Caramel ombré", code: "T 27", swatch: "linear-gradient(180deg,#5c3a1d 0%,#a76a2e 100%)", category: C.ombreT },
  { id: "t3327", name: "Brun → Caramel", code: "T 33/27", swatch: "linear-gradient(180deg,#5c2410 0%,#a76a2e 100%)", category: C.ombreT },
  { id: "tbuggold", name: "Bordeaux → Or", code: "T BUG/GOLD", swatch: "linear-gradient(180deg,#5a1424 0%,#dcb821 100%)", category: C.ombreT },
  { id: "t1b350", name: "Noir → Roux", code: "T 1B/350", swatch: "linear-gradient(180deg,#0d0a08 0%,#9c2e15 100%)", category: C.ombreT },
  { id: "t1b30", name: "Noir → Auburn", code: "T 1B/30", swatch: "linear-gradient(180deg,#0d0a08 0%,#8b4a22 100%)", category: C.ombreT },
  { id: "tgrey2", name: "Gris ombré", code: "T GREY2", swatch: "linear-gradient(180deg,#3a3a3d 0%,#a8a8ad 100%)", category: C.ombreT },
  { id: "t1bgrey1", name: "Noir → Gris", code: "T 1B/GREY1", swatch: "linear-gradient(180deg,#0d0a08 0%,#c5c5c8 100%)", category: C.ombreT },
  { id: "t1b33", name: "Noir → Brun-rouge", code: "T 1B/33", swatch: "linear-gradient(180deg,#0d0a08 0%,#5c2410 100%)", category: C.ombreT },
  { id: "t1b2pur", name: "Noir → Violet 2", code: "T 1B/2PUR", swatch: "linear-gradient(180deg,#0d0a08 0%,#6d10a3 100%)", category: C.ombreT },
  { id: "tpurpink", name: "Violet → Rose", code: "TPUR/PINK", swatch: "linear-gradient(180deg,#8b1ab1 0%,#e8a4c5 100%)", category: C.ombreT },

  // ─── Mèches Piano (P) ───
  { id: "p3033", name: "Auburn / Brun-rouge", code: "P 30/33", swatch: "linear-gradient(90deg,#8b4a22 50%,#5c2410 50%)", category: C.pianoP },
  { id: "p30613", name: "Auburn / Platine", code: "P 30/613", swatch: "linear-gradient(90deg,#8b4a22 50%,#e8d6a5 50%)", category: C.pianoP },
  { id: "p2733613", name: "Tri-blonds", code: "P 27/33/613", swatch: "linear-gradient(90deg,#a76a2e 0 33%,#5c2410 33% 66%,#e8d6a5 66%)", category: C.pianoP },
  { id: "p2730613", name: "Caramel / Auburn / Platine", code: "P 27/30/613", swatch: "linear-gradient(90deg,#a76a2e 0 33%,#8b4a22 33% 66%,#e8d6a5 66%)", category: C.pianoP },
  { id: "p27613", name: "Caramel / Platine", code: "P 27/613", swatch: "linear-gradient(90deg,#a76a2e 50%,#e8d6a5 50%)", category: C.pianoP },
  { id: "p2733", name: "Caramel / Brun-rouge", code: "P 27/33", swatch: "linear-gradient(90deg,#a76a2e 50%,#5c2410 50%)", category: C.pianoP },
  { id: "p24171", name: "Miel / Châtain", code: "P 24/171", swatch: "linear-gradient(90deg,#b58d52 50%,#7a5a40 50%)", category: C.pianoP },
  { id: "p227613", name: "Brun / Caramel / Platine", code: "P 2/27/613", swatch: "linear-gradient(90deg,#2a1a12 0 33%,#a76a2e 33% 66%,#e8d6a5 66%)", category: C.pianoP },
  { id: "p2730", name: "Caramel / Auburn", code: "P 27/30", swatch: "linear-gradient(90deg,#a76a2e 50%,#8b4a22 50%)", category: C.pianoP },
  { id: "p427", name: "Brun / Caramel", code: "P 4/27", swatch: "linear-gradient(90deg,#3a261a 50%,#a76a2e 50%)", category: C.pianoP },

  // ─── Ombré 3 tons (OT) ───
  { id: "ot427", name: "OT Brun → Caramel", code: "OT 4/27", swatch: "linear-gradient(180deg,#3a261a 0%,#5c2410 50%,#a76a2e 100%)", category: C.ombreOT },
  { id: "ot1bpur", name: "OT Noir → Violet", code: "OT 1B/PUR", swatch: "linear-gradient(180deg,#0d0a08 0%,#3a0a3a 50%,#8b1ab1 100%)", category: C.ombreOT },
  { id: "ot430", name: "OT Brun → Auburn", code: "OT 4/30", swatch: "linear-gradient(180deg,#3a261a 0%,#5c3a1d 50%,#8b4a22 100%)", category: C.ombreOT },
  { id: "ot4613", name: "OT Brun → Platine", code: "OT 4/613", swatch: "linear-gradient(180deg,#3a261a 0%,#a76a2e 50%,#e8d6a5 100%)", category: C.ombreOT },
  { id: "ot4gold", name: "OT Brun → Or", code: "OT 4/GOLD", swatch: "linear-gradient(180deg,#3a261a 0%,#8b4a22 50%,#dcb821 100%)", category: C.ombreOT },
  { id: "ot3027", name: "OT Auburn → Caramel", code: "OT 30/27", swatch: "linear-gradient(180deg,#8b4a22 0%,#a76a2e 100%)", category: C.ombreOT },
  { id: "ot3327", name: "OT Brun-rouge → Caramel", code: "OT 33/27", swatch: "linear-gradient(180deg,#5c2410 0%,#a76a2e 100%)", category: C.ombreOT },
  { id: "ot1bgreen", name: "OT Noir → Vert", code: "OT 1B/GREEN", swatch: "linear-gradient(180deg,#0d0a08 0%,#1a3a2a 50%,#0e4d3a 100%)", category: C.ombreOT },
  { id: "ot1b27", name: "OT Noir → Caramel", code: "OT 1B/27", swatch: "linear-gradient(180deg,#0d0a08 0%,#5c3a1d 50%,#a76a2e 100%)", category: C.ombreOT },
  { id: "ot3330", name: "OT Brun-rouge → Auburn", code: "OT 33/30", swatch: "linear-gradient(180deg,#5c2410 0%,#8b4a22 100%)", category: C.ombreOT },
  { id: "ot1bbug", name: "OT Noir → Bordeaux", code: "OT 1B/BUG", swatch: "linear-gradient(180deg,#0d0a08 0%,#3a0a16 50%,#5a1424 100%)", category: C.ombreOT },
  { id: "ot1b350", name: "OT Noir → Roux feu", code: "OT 1B/350", swatch: "linear-gradient(180deg,#0d0a08 0%,#5a1a10 50%,#9c2e15 100%)", category: C.ombreOT },

  // ─── Curly C-series ───
  { id: "b29", name: "B29 — Brun warm", code: "B29", swatch: "#604027", category: C.curly },
  { id: "c14", name: "C14 — Cuivre doré", code: "C14", swatch: "#9a6b3a", category: C.curly },
  { id: "c15", name: "C15 — Caramel doux", code: "C15", swatch: "#b88460", category: C.curly },
  { id: "c16", name: "C16 — Châtain blond", code: "C16", swatch: "#a47b4a", category: C.curly },
  { id: "c17", name: "C17 — Noir & Violet", code: "C17", swatch: "linear-gradient(180deg,#0d0a08 50%,#6d10a3 50%)", category: C.curly },
];

export const COLOR_CATEGORIES = [C.natural, C.vivid, C.pastel, C.ombreT, C.pianoP, C.ombreOT, C.curly];

export const LENGTHS = [
  { id: "long", label: '24"', subtitle: "Long — taille" },
];

export const FAQS = [
  {
    q: "Combien de paquets sont nécessaires pour une pose complète ?",
    a: "1 à 2 paquets selon la densité souhaitée. Pour une coiffure naturelle et complète, 2 à 3 paquets sont parfaits.",
  },
  {
    q: "La fibre est-elle réglable à l'eau chaude ?",
    a: "Oui, notre French Curl est thermo-réglable. Trempez-la dans de l'eau bien chaude pendant 5 secondes pour activer et fixer la boucle.",
  },
  {
    q: "Quels sont les délais de livraison ?",
    a: "Expédition sous 24h ouvrées. France métropolitaine : 2 à 4 jours (5,90€). Europe : 4 à 7 jours (9,90€). Click & Collect en salon partenaire gratuit en 24 à 48h.",
  },
  {
    q: "Qu'est-ce que le click & collect salon partenaire ?",
    a: "Vous récupérez votre commande gratuitement dans l'un de nos salons partenaires en 24 à 48h. Liste communiquée via WhatsApp.",
  },
  {
    q: "Puis-je laver et réutiliser le produit ?",
    a: "Oui, avec un shampoing doux et de l'eau tiède. Laissez sécher à l'air libre, ne brossez jamais à sec.",
  },
  {
    q: "Comment passer commande ?",
    a: "Sélectionnez votre couleur, votre longueur et votre mode de livraison, puis cliquez sur le bouton WhatsApp. Votre message sera pré-rempli — il ne reste qu'à valider.",
  },
];

export const TESTIMONIALS = [
  { name: "Awa K.", city: "Paris", rating: 5, text: "Texture incroyable, le rendu est exactement comme sur les photos. Posé en 2h et tenu 6 semaines parfaitement." },
  { name: "Léa M.", city: "Lyon", rating: 5, text: "Je suis fan de la couleur miel, elle est lumineuse au soleil. Et le toucher est ultra doux, pas du tout synthétique." },
  { name: "Fatou D.", city: "Marseille", rating: 5, text: "Service au top via WhatsApp, livraison rapide. J'ai recommandé en ombré, hâte de tester." },
  { name: "Sarah B.", city: "Bordeaux", rating: 5, text: "Ce qui m'a bluffée : aucune odeur chimique, et la fibre ne s'emmêle vraiment pas. À 7,50€ la pièce c'est imbattable." },
];
